const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/fields/UnfallArtField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const UnfallArtField = generateMetaKatDropDownField('f80978f2-f396-4593-8475-2ba969afe259', 'UnfallArtField');
export default UnfallArtField;
